/* global axios */
import ApiClient from './ApiClient';

class AgendamentoAPI extends ApiClient {
  constructor() {
    super('agendamento', { accountScoped: true });
  }

  getConfig() {
    return axios.get(`${this.url}/show_config`);
  }

  createConfig(data) {
    return axios.post(`${this.url}/create_config`, { agendamento_config: data });
  }

  updateConfig(data) {
    return axios.put(`${this.url}/update_config`, { agendamento_config: data });
  }

  deleteConfig() {
    return axios.delete(`${this.url}/destroy_config`);
  }

  uploadLogo(file) {
    const formData = new FormData();
    formData.append('logo', file);
    return axios.post(`${this.url}/upload_logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  removeLogo() {
    return axios.delete(`${this.url}/remove_logo`);
  }

  getAvaliadoras() {
    return axios.get(`${this.url}/avaliadoras`);
  }

  getHorarios(data) {
    return axios.get(`${this.url}/horarios`, { params: { data } });
  }

  agendar(payload) {
    return axios.post(`${this.url}/agendar`, payload);
  }

  cancelar(payload) {
    return axios.post(`${this.url}/cancelar`, payload);
  }
}

export default new AgendamentoAPI();
